module.exports = __webpack_public_path__ + "img/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.835fd7b7.webp";